import axios from "axios";
import { sisikong_url } from "../../../../api";
import type {
  SubmitQuotationRequestRQ,
  SubmitQuotationRequestRS,
} from "../../../../api/quotation/types";
import { baseUrl } from "../../api/constants";

// App User List Interfaces
export interface AppUserDef {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  tags: string[];
}

export interface GetAppUserListResponse {
  count: number;
  results: AppUserDef[];
}

// Get list of app users
export async function getAppUserList(
  source_entity: string,
  token: string,
): Promise<GetAppUserListResponse> {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const response = await axios.get<GetAppUserListResponse>(
    `${sisikong_url}/crm/external/apollo-b2b/app-user-list`,
    { headers, params: { source_entity } },
  );
  return response.data;
}

// Submit quotation request
export function createQuotationRequest({
  payload,
  token,
}: {
  payload: SubmitQuotationRequestRQ;
  token: string;
}): Promise<{ data: SubmitQuotationRequestRS }> {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`${baseUrl}/api/v1/submit-quotation-request`, payload, { headers });
}
